<template>
  <div class="loading-queue">
    <div v-for="trx in trxData" :key="trx.id">
      <svg v-if="!loading(trx.status)" t="1578724364855" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2907" width="12" height="12"><path d="M512 512m-512 0a512 512 0 1 0 1024 0 512 512 0 1 0-1024 0Z" fill="#1FC756" p-id="2908"></path><path d="M328.042338 498.089354l102.699324 102.557538 263.404307-264.8064a40.329846 40.329846 0 0 1 57.076185-0.1024 40.440123 40.440123 0 0 1 0.086646 57.162831L467.708062 677.6832a55.138462 55.138462 0 0 1-78.0288 0.110277L273.880615 562.176a45.591631 45.591631 0 0 1-2.615138-61.692062 38.612677 38.612677 0 0 1 56.776861-2.394584z" fill="#FFFFFF" p-id="2909"></path></svg>
      <svg v-if="loading(trx.status)" t="1578724818068" class="loading-icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3963" width="12" height="12"><path d="M512 981.312a469.312 469.312 0 1 0-445.824-322.24A42.688 42.688 0 1 0 147.2 632.32 384 384 0 1 1 512 896a42.688 42.688 0 1 0 0 85.312z" p-id="3964" fill="#1afa29"></path></svg>
      <span> {{ showTrx(trx.id) }} </span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'loadingQueue',
  computed: {
    ...mapState({
      trxData: state => state.trxData,
    }),
  },
  methods: {
    showTrx(trx) {
      return trx.slice(0, 10) + '...' + trx.slice(-10);
    },
    loading(trx) {
      if (trx === 'loading') return true;
      return false;
    }
  }
}
</script>

<style lang="less">
@media (max-width: 600px) {
  .loading-queue {
    position: relative !important;
    right: 0 !important;
    bottom: 0 !important;
    margin-top: 12px;
    margin-bottom: 24px;
  }
}
.loading-queue {
  position: fixed;
  right: 24px;
  bottom: 24px;
}
.loading-icon {
  animation: LoadingSpin 1s linear infinite;
}

@keyframes LoadingSpin {
  0%{ transform: rotate(0deg);}
  50%{ transform: rotate(180deg);}
  100%{ transform: rotate(360deg);}
}
</style>